import React, { useContext } from 'react'
import '../../../styles/comedyHome.css'
import ComedySwiper from './comedySwiper'
import YtPlayer from './ytPlayer'
import  SectionSmall from './sectionSmall'
import { Helmet } from 'react-helmet-async'
import { DeviceContext } from '..'
import PageAds from '../../common/pageAds'

const ComedyHome = ({data}) => {


             const  ssrData = data?.[0]?.homePage || {};
             const {mobile,setMobile,containerRef} = useContext(DeviceContext)


    return (
        <div className='container-fluid comedy-home-container'>
           <Helmet><title>TeluguOne.com: Telugu Comedy | Telugu Jokes | Telugu Comedy Stories | Telugu Cartoon Jokes | Telugu comedy videos</title></Helmet>
                {!mobile && <div className='row g-0'>
                   <div className='col-7 d-none d-sm-flex justify-content-center align-items-center'>
                      <ComedySwiper  data={ssrData.homeSlider} dataError={ssrData.homeSliderError} />
                   </div>
                   <div className='col-5 d-none d-sm-flex flex-column justify-content-center align-items-center'>
                    {ssrData.latestYoutubeVideo && <h1 className='yt-title'>Navvula Tv</h1>}
                     <YtPlayer latestYoutubeVideo={ssrData.latestYoutubeVideo} 
                     latestYoutubeVideoError={ssrData.latestYoutubeVideoError}  />
                   </div>
                </div>}
            <div className='row g-0'>
                 <div className='home-main-heading'>Mallik Corner</div>
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyVideoCategoryJson.php'} title={'vgal_title'} heading={"Shhh Gup Chip"} catId={5} 
                 cards={ssrData.vListOne} link={'/videoslist/shhhgupchip-5.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyVideoCategoryJson.php'} title={'vgal_title'} heading={"Happy Happyga"} catId={4} 
                 cards={ssrData.vListTwo} link={'/videoslist/happyhappyga-4.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyVideoCategoryJson.php'} title={'vgal_title'}  heading={"Mallik Comedy"} catId={6}
                  cards={ssrData.vListThree} link={'/videoslist/mallikcomedy-6.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyVideoCategoryJson.php'}  title={'vgal_title'}  heading={"Erri Dippa"} catId={25} 
                 cards={ssrData.vListFour} link={'/videoslist/erridippa-25.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyVideoCategoryJson.php'} title={'vgal_title'}  heading={"Movie Spoofs"} catId={26}
                  cards={ssrData.vListFive} link={'/videoslist/spoofs-26.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyVideoCategoryJson.php'} title={'vgal_title'}  heading={"Gossips"} catId={31}
                  cards={ssrData.vListSix} link={'/videoslist/archives-31.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                  <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'} heading={"Audio Jokes"} catId={669}
                   cards={ssrData.contentsOne} link={'/contents/audiojokes-669.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                  <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'} heading={"Audio Cartoons"} catId={6}
                   cards={ssrData.contentsTwo} link={'/contents/audiocartoons-6.html'} />
                  </div> 
                 <div className='col-md-6 col-12'>
                  <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'}  heading={"MallikKrazy"} catId={641}
                   cards={ssrData.contentsThree} link={'/contents/mallikkrazy-641.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                  <SectionSmall type={'comedyContentCategoryJson.php'}  title={'title'}  heading={"Hot Shot"} catId={26}
                   cards={ssrData.contentsFour} link={'/contents/hotshot-26.html'} />
                  </div> 
                 <div className='col-md-6 col-12'>
                  <SectionSmall type={'comedyContentCategoryJson.php'}  title={'title'} heading={"Siggu Siggu"} catId={25} 
                  cards={ssrData.contentsFive} link={'/contents/siggusiggu-25.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                  <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'}  heading={"Facebook Fun"} catId={1168} 
                  cards={ssrData.contentsSix} link={'/contents/facebook-fun-1168.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                  <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'}  heading={"Jokes"} catId={23}
                   cards={ssrData.contentsSeven} link={'/contents/jokes-23.html'} />
                 </div> 
                 <div className='col-md-6 col-12'> 
                  <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'}  heading={"Miscellaneous"} catId={942} 
                  cards={ssrData.contentsEight} link={'/contents/cheapeyrayudu-942.html'} />
                </div> 
                 <div className='col-md-6 col-12'>
                  <SectionSmall type={'comedyGalleryCategoryJson.php'} title={'folder_name'}  heading={"Chitti"} catId={11}
                   cards={ssrData.galleryOne} link={'/galleries/Chitti-Archive-11-1.html'} />
                  </div> 
                
            </div>         
               
                 <PageAds  mobile={mobile} containerRef={containerRef} />
             </div>     
        
      )
}

export default ComedyHome;
